<template>
  <v-autocomplete
    :clearable="clearable"
    v-bind="$attrs"
    v-on="$listeners"
    v-model="innerValue"
    clear-icon="clear"
    @change="onChange"
    :items="items"
    :name="randomName"
    :id="randomName"
    :autocomplete="randomName"
    ref="autoSelect"
  >
    <template v-slot:selection="data" v-if="slots == true">
      <slot name="selection" v-bind="data"></slot>
    </template>
    <template v-slot:item="data" v-if="slots == true">
      <slot name="item" v-bind="data"></slot>
    </template>
    <template v-slot:prepend v-if="showAddBtn !== undefined">
      <v-btn
        rounded
        small
        color="primary"
        @click="$emit('add')"
        :disabled="!showAddBtn"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: ["value", "slots", "items", "clearable", "showAddBtn"],
  data() {
    return {
      innerValue: null,
      randomName: "",
    };
  },
  watch: {
    value: {
      handler(v) {
        this.innerValue = v;
      },
      immediate: true,
    },
    innerValue: {
      handler(v) {
        console.log("AutoSelect inner change: ", v);
        this.$emit("update:value", v);
        this.$emit("change", v);
      },
    },
    items: {
      handler(v) {
        if (v) {
          if (!this.clearable) {
            // console.log(this.items, this.clearable)
            if (this.items && this.items.length === 1) {
              this.$nextTick(() => {
                this.innerValue = this.items[0];
              });
            }
          }
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.randomName = this.getRandomName();
  },
  methods: {
    onChange(val) {
      console.log("AutoSelect on change: ", val);
      this.$emit("change", val);
    },
    getRandomName() {
      return Math.random().toString();
    },
  },
};
</script>
